import { gql } from '@apollo/client';

export const ALL_PROFILES = gql`
  query allProfiles {
    allProfiles {
      result {
        permissions
        name
        id
      }
    }
  }
`;
